import React, { useEffect, useState } from "react";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import DialogActions from "@mui/material/DialogActions";
import MDButton from "components/MDButton";
import { Button, Divider } from "@mui/material";
import MDTypography from "components/MDTypography";

import { Delete } from "@mui/icons-material";

import { useDeleteProgramme } from "hooks/settingsHooks/useDeleteProgramme";
import { toast } from "sonner";

const DeleteProgrammePopup = ({ programme }) => {
  const [open, setOpen] = useState(false);
  const [programmename, setProgrammename] = useState("Information Technology");
  const { deleteprogramme, error, isLoading, success, setError, setSuccess } =
    useDeleteProgramme();

  useEffect(() => {
    if (programme) {
      setProgrammename(programme.programmename);
    }
  }, [programme]);

  useEffect(() => {
    if (error) {
      toast.error("Failed to delete programme");
    }
    if (success) {
      toast.success("Programme deleted successfully");
      handleClose();
    }
  }, [error, success]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    await deleteprogramme(programme.id);
    handleClose();
  };

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
    setError(null);
    setSuccess(null);
  };

  return (
    <div>
      <Button onClick={handleClickOpen}>
        <Delete sx={{ cursor: "pointer", fontWeight: "bold" }} color="error" />
      </Button>
      <Dialog
        open={open}
        onClose={handleClose}
        maxWidth="xs"
        fullWidth
        PaperProps={{
          style: { padding: 5, borderRadius: 10 },
        }}
      >
        <DialogTitle display="flex" justifyContent="center">
          Confirm Delete
        </DialogTitle>
        <Divider sx={{ my: 0 }} />
        <DialogContent>
          <MDTypography
            display="flex"
            flexDirection="column"
            textAlign="center"
          >
            Are you sure you want to delete <strong>{programmename}</strong>?
          </MDTypography>
        </DialogContent>
        <DialogActions>
          <MDButton onClick={handleClose} color="secondary" variant="contained">
            No
          </MDButton>
          <MDButton onClick={handleSubmit} color="error" variant="contained">
            Yes
          </MDButton>
        </DialogActions>
      </Dialog>
    </div>
  );
};

export default DeleteProgrammePopup;
